import * as React from "react";
import {Fragment, Component} from "react";

class Modal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			show: false
		}
	}

	componentDidMount() {
		this.setState({show: true});
	}

	render() {

		const {show} = this.state;
		const {id, title, children, size, onClose} = this.props;

		return (
			<Fragment>
				<div className={`modal fade ${show ? 'show' : ''} d-block`} id={id} tabIndex="-1" aria-labelledby={`${id}ModalLabel`} aria-hidden="true" style={{zIndex: 2026}} >
					<div className={`modal-dialog${size ? (' modal-' + size) : ''} modal-dialog-centered`} >
						<div className="modal-content">
							<div className="modal-header">
								<h1 className="modal-title fs-5" id="exampleModalLabel">{title}</h1>
								<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => onClose()}></button>
							</div>
							<div className="modal-body">
								{children}
							</div>
						</div>
					</div>
					<div className="modal-backdrop fade show" style={{zIndex: 2025}} onClick={() => onClose()} />
				</div>
			</Fragment>
		);
	}
}

export default Modal;
